<div class="mi">
  @if (farAway()) {
    <app-badge-variant
      badge="none"
      backgroundColor="var(--far-away-background-color)"
      label="W"
      [tooltip]="'ASSIGNMENT.WEIT_WEG' | translate" />
  }
  @if (miWarning()) {
    <app-badge-variant
      badge="warning"
      [label]="'ASSIGNMENT.MIAUFTRAG' | translate"
      [tooltip]="'ASSIGNMENT.MIAUFTRAGSTATUS.1' | translate" />
  }
  @if (miOk()) {
    <app-badge-variant
      badge="check"
      [label]="'ASSIGNMENT.MIAUFTRAG' | translate"
      [tooltip]="'ASSIGNMENT.MIAUFTRAGSTATUS.2' | translate" />
  }
  @if (miProbSolutions()) {
    <app-badge-variant
      badge="none"
      label="{{ assignment().NumMIProbSolutions }}"
      tooltip="{{ assignment().MIProbSolutionIDs }}" />
  }
  @if (mainPrimeLogistic()) {
    <app-badge-variant
      badge="none"
      label="PL"
      [shape]="Shape.Shield"
      backgroundColor="var(--prime-logistics-color-1)"
      [tooltip]="'ASSIGNMENT.INFOFILTER.PRIME_LOGISTIC' | translate" />
  }
</div>
